import { BinaryDataType } from './types';

export default [
  {
    type: 'final',
    startIndex: 1,
    length: 3,
    label: {
      tr: 'Tespit/Teşhis Durumu',
      en: 'Detection/Identification Status',
      ar: 'حالة الكشف/التعرف',
      es: 'Detection/Identification Status',
      it: 'Detection/Identification Status',
      ro: 'Detection/Identification Status',
    },
    isReserved: false,
    conditions: [],
    options: [
      {
        binary: '000',
        value: 0,
        label: {
          tr: 'Tespit veya Teşhis Edilmemiş',
          en: 'Not Detected or Identified',
          ar: 'لم يتم الكشف أو التعرف عليه',
          es: 'Not Detected or Identified',
          it: 'Not Detected or Identified',
          ro: 'Not Detected or Identified',
        },
      },
      {
        binary: '001',
        value: 1,
        label: {
          tr: 'Tespit Edilmiş',
          en: 'Detected',
          ar: 'تم الكشف عنه',
          es: 'Detected',
          it: 'Detected',
          ro: 'Detected',
        },
      },
      {
        binary: '010',
        value: 2,
        label: {
          tr: 'Tür Teşhis Edilmiş',
          en: 'Prototype Identified',
          ar: 'تم التعرف على النموذج',
          es: 'Prototype Identified',
          it: 'Prototype Identified',
          ro: 'Prototype Identified',
        },
      },
      {
        binary: '011',
        value: 3,
        label: {
          tr: 'Taraf Teşhis Edilmiş',
          en: 'Side Identified',
          ar: 'تم التعرف على الجانب',
          es: 'Side Identified',
          it: 'Side Identified',
          ro: 'Side Identified',
        },
      },
      {
        binary: '100',
        value: 4,
        label: {
          tr: 'Tür ve Taraf Teşhis Edilmiş',
          en: 'Prototype and Side Identified',
          ar: 'تم التعرف على النموذج والجانب',

          es: 'Prototype and Side Identified',
          it: 'Prototype and Side Identified',
          ro: 'Prototype and Side Identified',
        },
      },
      {
        binary: '101',
        value: 5,
        label: {
          tr: 'Kimlik Teşhis Edilmiş',
          en: 'Identity Identified',
          ar: 'تم التعرف على الهوية',
          es: 'Identity Identified',
          it: 'Identity Identified',
          ro: 'Identity Identified',
        },
      },
      {
        binary: '110',
        value: 6,
        label: {
          tr: 'Temas Kayıp',
          en: 'Contact Loss',
          ar: 'فقدان الاتصال',
          es: 'Contact Loss',
          it: 'Contact Loss',
          ro: 'Contact Loss',
        },
      },
      {
        binary: '111',
        value: 7,
        label: {
          tr: 'Kendisi',
          en: 'Self',
          ar: 'الذات',
          es: 'Self',
          it: 'Self',
          ro: 'Self',
        },
      },
    ],
  },
] as BinaryDataType[];
